class LoadMoreItems extends HTMLElement {
	constructor() {
		super()

		this.pagination = document.querySelector('[data-pagination]')
		this.items = document.querySelector('[data-items]')

		// no pagination list - no need for all the logic
		if(this.pagination && this.items) {
			const currentPage = parseInt(this.pagination.children[0].dataset.page)
			const maxPages = parseInt(this.pagination.children[0].dataset.maxPages)
			this.pagination.classList.add('hidden')
			if(currentPage < maxPages) {
				this.children[0].addEventListener('click', this.loadItems.bind(this))
			}

		}

	}

	loadItems() {

		// console.log('load items')

		// refresh pagination element if filtered data
		const pagination = document.querySelector('[data-pagination]')
		const currentPage = parseInt(pagination.children[0].dataset.page)
		const maxPages = parseInt(pagination.children[0].dataset.maxPages)

		const nextPageUrl = pagination.children[0].children[currentPage].children[0].href
		this.fetchPosts(nextPageUrl)

		if(currentPage+1 == maxPages) {
			this.classList.add('hidden')
			this.nextElementSibling?.classList.remove('hidden')
			// console.log('loaded everything')
		}

	}

	fetchPosts(url) {

		// console.log('fetch posts')

	  return fetch(url)
      .then((response) => {
        return response.text()
      })
      .then((html) => {

        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')

        const itemsLoaded = doc.querySelector('[data-items]')
        const paginationLoaded = doc.querySelector('[data-pagination]')

        Array.from(itemsLoaded.children).forEach((item) => {
        	this.items.appendChild(item)
        })
				this.pagination.innerHTML = paginationLoaded.innerHTML
				console.log(this.pagination)

      })
      .catch((err) => {
        console.warn('Something went wrong.', err)
      })
      .finally(() => {
      	this.classList.remove('loading')
      })

  }

}

customElements.define('load-more-items', LoadMoreItems)